import React from 'react'
import { Button, Separator } from '@fs/zion-ui'
import { useParams } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import AddNoteButton from '../../components/collaborate/AddNoteButton'
import { NotesLoading } from './NotesLoading'

export default function MiniNotesLoading(): JSX.Element {
  const [t] = useTranslation()
  const { pid } = useParams()

  return (
    <>
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <AddNoteButton disabled />
      <Separator size="nano" />
      <NotesLoading />
      <Separator size="nano" />
      <Button data-testid="show-all" linkName="Mini Notes: Show All" to={`/collaborate/${pid}`}>
        {t('tree-person.show-all.action')}
      </Button>
    </>
  )
}
